"use client";

import React from "react";
import { ArrowDown } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SystemIdentity() {
  const {
    ref: headingRef,
    isVisible: isHeadingVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: separatorRef,
    isVisible: isSeparatorVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: buttonRef,
    isVisible: isButtonVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224011" id="know-your-timbers-worth" className="relative min-h-screen flex flex-col items-center justify-center bg-background overflow-hidden py-24 px-6 sm:px-10">
      {}
      <style>{`
        @keyframes subtle-pulse-scale {
          0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(245, 158, 11, 0); }
          50% { transform: scale(1.02); box-shadow: 0 0 20px 0 rgba(245, 158, 11, 0.3); }
        }
        .animate-subtle-pulse {
          animation: subtle-pulse-scale 4s ease-in-out infinite;
        }
        @keyframes scan-line {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(1000%); }
        }
        .scanning-line {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 2px;
          background: linear-gradient(to right, transparent, hsl(38, 92%, 50%), transparent);
          opacity: 0.5;
          animation: scan-line 8s linear infinite;
          z-index: 5;
        }
      `}</style>

      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645510/img/dense_forest_canopy_aerial.png" alt="Aerial Forest View" className="absolute inset-0 w-full h-full object-cover opacity-40 grayscale" />
        <div className="absolute inset-0 bg-background/80 backdrop-blur-[2px]"></div>
        <div className="scanning-line"></div>
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-[0.1] [mask-image:radial-gradient(ellipse_80%_80%_at_50%_50%,#000_20%,transparent_100%)]"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto flex flex-col items-center text-center">
        {}
        <div ref={headingRef} className={`transition-all duration-1000 ease-out transform ${isHeadingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-default text-5xl sm:text-6xl md:text-7xl lg:text-[5rem] font-bold tracking-tighter leading-[1.1] text-foreground max-w-4xl mx-auto">Helping landowners make smarter timber decisions</h1>
        </div>

        {}
        <div ref={separatorRef} className={`my-12 md:my-16 transition-all duration-1000 delay-300 ease-out h-24 md:h-32 flex items-center justify-center ${isSeparatorVisible ? "opacity-100 scale-y-100" : "opacity-0 scale-y-0"} origin-top`}>
          <Separator orientation="vertical" className="h-full w-[2px] bg-chart-2/40" />
        </div>

        {}
        <div ref={textRef} className={`transition-all duration-1000 delay-500 ease-out transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-mono text-lg md:text-xl text-secondary-foreground leading-relaxed max-w-2xl mx-auto">The Timber Composition Analysis gives landowners a clear, unbiased understanding of their timber, before they commit time, money, or access.</p>
        </div>

        {}
        <div ref={buttonRef} className={`mt-16 md:mt-20 transition-all duration-1000 delay-700 ease-out transform ${isButtonVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="animate-subtle-pulse inline-block">
            <Button asChild size="lg" className="rounded-sm px-8 py-6 text-base tracking-wide uppercase font-semibold shadow-2xl bg-chart-2 text-black hover:bg-chart-2/90 border-none">
              <Link to="/RequestConversationPage">
                Request a Conversation
                <ArrowDown className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}